import React from 'react';
import { UserIcon, PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
export const GeneralInfo = () => {
  return <div className="space-y-8" data-id="element-803">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-804">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-805">
          <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-806">
            Información Personal
          </h2>
          <div className="space-y-4" data-id="element-807">
            <div className="flex items-start" data-id="element-808">
              <UserIcon className="h-5 w-5 text-gray-400 mt-0.5 mr-3" data-id="element-809" />
              <div data-id="element-810">
                <p className="text-sm font-medium text-gray-500" data-id="element-811">
                  Nombre Completo
                </p>
                <p className="text-base font-medium" data-id="element-812">Juan Pérez Gómez</p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-813">
              <UserIcon className="h-5 w-5 text-gray-400 mt-0.5 mr-3" data-id="element-814" />
              <div data-id="element-815">
                <p className="text-sm font-medium text-gray-500" data-id="element-816">
                  Identificación
                </p>
                <p className="text-base font-medium" data-id="element-817">DNI: 12345678</p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-818">
              <PhoneIcon className="h-5 w-5 text-gray-400 mt-0.5 mr-3" data-id="element-819" />
              <div data-id="element-820">
                <p className="text-sm font-medium text-gray-500" data-id="element-821">Teléfono</p>
                <p className="text-base font-medium" data-id="element-822">+51 987 654 321</p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-823">
              <MailIcon className="h-5 w-5 text-gray-400 mt-0.5 mr-3" data-id="element-824" />
              <div data-id="element-825">
                <p className="text-sm font-medium text-gray-500" data-id="element-826">Correo</p>
                <p className="text-base font-medium" data-id="element-827">juan.perez@ejemplo.com</p>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-828">
          <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-829">Dirección</h2>
          <div className="space-y-4" data-id="element-830">
            <div className="flex items-start" data-id="element-831">
              <MapPinIcon className="h-5 w-5 text-gray-400 mt-0.5 mr-3" data-id="element-832" />
              <div data-id="element-833">
                <p className="text-sm font-medium text-gray-500" data-id="element-834">Domicilio</p>
                <p className="text-base font-medium" data-id="element-835">Av. Principal 123</p>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-836">
              <div data-id="element-837">
                <p className="text-sm font-medium text-gray-500" data-id="element-838">Ciudad</p>
                <p className="text-base font-medium" data-id="element-839">Lima</p>
              </div>
              <div data-id="element-840">
                <p className="text-sm font-medium text-gray-500" data-id="element-841">Distrito</p>
                <p className="text-base font-medium" data-id="element-842">San Isidro</p>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-843">
              <div data-id="element-844">
                <p className="text-sm font-medium text-gray-500" data-id="element-845">Provincia</p>
                <p className="text-base font-medium" data-id="element-846">Lima</p>
              </div>
              <div data-id="element-847">
                <p className="text-sm font-medium text-gray-500" data-id="element-848">
                  Código Postal
                </p>
                <p className="text-base font-medium" data-id="element-849">15046</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-850">
        <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-851">
          Historial Crediticio
        </h2>
        <div className="overflow-x-auto" data-id="element-852">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-853">
            <thead className="bg-gray-50" data-id="element-854">
              <tr data-id="element-855">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-856">
                  Entidad
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-857">
                  Producto
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-858">
                  Monto
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-859">
                  Estado
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-860">
                  Fecha
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-861">
              <tr data-id="element-862">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-863">
                  Banco ABC
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-864">
                  Préstamo Personal
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-865">
                  S/ 15,000.00
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-866">
                  <span className="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-867">
                    Al día
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-868">
                  15/01/2023
                </td>
              </tr>
              <tr data-id="element-869">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-870">
                  Financiera XYZ
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-871">
                  Tarjeta de Crédito
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-872">
                  S/ 5,200.00
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-873">
                  <span className="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800" data-id="element-874">
                    En mora
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-875">
                  03/11/2023
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};